/**
 * Google Analytics Event Tracking Utility
 * Only tracks events on production domain (www.joinblockclub.com)
 */

const isProduction = () => {
  return window.location.hostname === 'www.joinblockclub.com';
};

/**
 * Track a custom event in Google Analytics
 * @param {string} eventName - The name of the event (e.g., 'login_success')
 * @param {object} params - Additional parameters for the event
 */
export const trackEvent = (eventName, params = {}) => {
  if (isProduction() && typeof window.gtag !== 'undefined') {
    window.gtag('event', eventName, params);
  }
};

// Login Events
export const trackLoginAttempt = (method = 'email_otp', email = null) => {
  trackEvent('login_attempt', {
    method,
    ...(email && { email }),
  });
};

export const trackLoginSuccess = (userId, method = 'email_otp') => {
  trackEvent('login_success', {
    method,
    user_id: userId,
  });
};

export const trackLoginFail = (method = 'email_otp', error = null) => {
  trackEvent('login_fail', {
    method,
    ...(error && { error }),
  });
};

// Coupon Redeem Events
export const trackCouponRedeemAttempt = (couponId, venueId = null, userId = null, source = null) => {
  trackEvent('coupon_redeem_attempt', {
    coupon_id: couponId,
    ...(venueId && { venue_id: venueId }),
    ...(userId && { user_id: userId }),
    ...(source && { source }), // 'coupon_list' or 'wishlist'
  });
};

export const trackCouponRedeemSuccess = (couponId, venueId = null, userId = null, source = null) => {
  trackEvent('coupon_redeem_success', {
    coupon_id: couponId,
    ...(venueId && { venue_id: venueId }),
    ...(userId && { user_id: userId }),
    ...(source && { source }), // 'coupon_list' or 'wishlist'
  });
};

export const trackCouponRedeemFail = (couponId, venueId = null, error = null, source = null) => {
  trackEvent('coupon_redeem_fail', {
    coupon_id: couponId,
    ...(venueId && { venue_id: venueId }),
    ...(error && { error }),
    ...(source && { source }), // 'coupon_list' or 'wishlist'
  });
};

// Event RSVP Events
export const trackEventRSVPAttempt = (eventId, eventName = null, userId = null) => {
  trackEvent('event_rsvp_attempt', {
    event_id: eventId,
    ...(eventName && { event_name: eventName }),
    ...(userId && { user_id: userId }),
  });
};

export const trackEventRSVPSuccess = (eventId, eventName = null, userId = null) => {
  trackEvent('event_rsvp_success', {
    event_id: eventId,
    ...(eventName && { event_name: eventName }),
    ...(userId && { user_id: userId }),
  });
};

export const trackEventRSVPFail = (eventId, error = null) => {
  trackEvent('event_rsvp_fail', {
    event_id: eventId,
    ...(error && { error }),
  });
};
